import * as React from 'react';

function SvgNavStudentIcon(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M15.086 1.406L8.5.084a1.83 1.83 0 00-1.097 0L.913 1.406a.569.569 0 000 1.094l.587.16v3.93a.998.998 0 00.6 1.8 1 1 0 00.6-1.8V2.986l4.703 1.28c.213.067.62.15 1.097 0L15.086 2.5a.569.569 0 000-1.094zM4.786 9.4C2.545 9.93 1 11.73 1 14.163v.314C1 16 3.382 16 6.398 16h3.204C12.498 16 15 16 15 14.477v-.314c0-2.432-1.547-4.233-3.788-4.763l-3.214 3.213-3.213-3.212zm2.617-4.135L4.41 4.452c-.162.427-.25.893-.25 1.382a3.804 3.804 0 003.834 3.834c2.142 0 3.835-1.785 3.835-3.834 0-.493-.09-.962-.254-1.392L8.5 5.266c-.477.15-.884.067-1.097 0z"
      />
    </svg>
  );
}

export default SvgNavStudentIcon;
